import { Injectable } from "@angular/core";
import {Observable, forkJoin, of} from "rxjs"; 
import {map, catchError} from 'rxjs/operators';

import { GenericHttpService } from "./../../../../shared/services/generic-http.service";
import { environment } from "./../../../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class OrderHighlightService {
  constructor(private genericHttp: GenericHttpService) {}

  getDataFromApi(api, filters) {
    return this.genericHttp.httpRequest({
      url: `${environment.gateWayHost}${api}`,
            query: filters,
            method: 'GET'
    }).pipe(
      catchError(this.genericHttp.handleError),
      map(this.genericHttp.responseData)
    );
  }
}
